import { AdminRole } from "@repo/api-dtos"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import * as React from "react"
import { PageHeader } from "@/components/layout"
import { Skeleton } from "@/components/ui/skeleton"
import { useAdminRolesContext } from "@/contexts/admin-roles-context"
import { ShippingPolicyConfigEditor } from "@/features/shipping-policy-config/ShippingPolicyConfigEditor"
import { useShippingPolicyConfig } from "@/queries/marketplace"

export const Route = createFileRoute("/configuration/shipping")({
	component: ShippingPolicyConfigurationPage,
})

function ShippingPolicyConfigurationPage() {
	const navigate = useNavigate()
	const { hasAnyRole, hasRole } = useAdminRolesContext()
	const canRead = hasAnyRole([
		AdminRole.Superadmin,
		AdminRole.MarketplaceOrderSupport,
	])
	const canEdit = hasRole(AdminRole.Superadmin)
	const { configVersion, isLoading, error, refetch } = useShippingPolicyConfig({
		enabled: canRead,
	})

	React.useEffect(() => {
		if (!canRead) navigate({ to: "/unauthorized" })
	}, [canRead, navigate])
	if (!canRead) return null

	return (
		<div className="flex max-w-5xl flex-col gap-6 p-6">
			<PageHeader
				title="Shipping configuration"
				description="Cross-region trade, Shield coverage and untracked letters per market. Each save is a new version, used by search, checkout and seller settings within a minute."
			/>
			{error ? (
				<p className="rounded-lg bg-bad-soft px-3 py-2 text-bad">
					Failed to load the configuration: {error.message}
				</p>
			) : isLoading || !configVersion ? (
				<div className="flex flex-col gap-3">
					<Skeleton className="h-[58px] w-full" />
					<Skeleton className="h-[58px] w-full" />
					<Skeleton className="h-[58px] w-full" />
					<Skeleton className="h-[58px] w-full" />
				</div>
			) : (
				<ShippingPolicyConfigEditor
					active={configVersion}
					canEdit={canEdit}
					onReload={() => refetch()}
				/>
			)}
		</div>
	)
}
